module.exports = __webpack_public_path__ + "media/svg-new/bot2-8b71fe5b.svg";